import React, { useEffect, useState } from "react";
//* import css
import cssClasses from "./EventQueuePage.module.css";

//* imports MUI
import { Box, Typography } from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import CropFreeIcon from "@mui/icons-material/CropFree";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

//* import subComponents
import Button from "../../../Subcomponents/Button";
import Search from "../../../Subcomponents/Search";
import StatusChip from "../../../Subcomponents/LeadStatusChip";

//* import Modals
import ScanConformationModal from "../../../Modals/ScanConformationModal/ScanConformationModal";
//* import store
import { useDispatch } from "react-redux";
import action from "../../../Redux Store/actions";
import { dismissLoader, presentLoader } from "../../../Services/loader";
import * as _ from "lodash";
import {
  getAllLeadsFromTokenLead,
  getLeadsForTokenPaymentDone,
} from "../../../Services/Queue";
import { useParams } from "react-router-dom";
import debounce from "lodash.debounce";
import { chain, set, find, uniqBy } from "lodash";
import { getEvent } from "../../../Services/Event";
import QueueBlocks from "../../../Subcomponents/QueueBlocks/QueueBlocks";
import { Network } from "@capacitor/network";
import { offlineToast } from "../../../Services/Toast";
import { useSelector } from "react-redux";
import DropDown from "../../../Subcomponents/DropDown";
import { getLaunches } from "../../../Services/FastBooking";
function EventQueuePage() {
  const { eventId, launchId } = useParams();
  const dispatch = useDispatch();
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);
  const [scanConformationModal, setScanConformationModal] = useState(false);
  const [leadData, setLeadData] = useState(null);
  const [allLeads, setAllLeads] = useState(null);
  const [totalTokenHolderLeadsCount, setTotalTokenHolderLeadsCount] =
    useState(0);
  const [leadsClearedCheckPointOneCount, setLeadsClearedCheckPointOneCount] =
    useState(0);
  const [leadsClearedCheckPointTwoCount, setLeadsClearedCheckPointTwoCount] =
    useState(0);
  const [leadsClearedCheckPointOne, setLeadsClearedCheckPointOne] =
    useState(null);
  const [leadsClearedCheckPointTwo, setLeadsClearedCheckPointTwo] =
    useState(null);
  const [search, setSearch] = useState("");
  const [searchCheckPointOne, setSearchCheckPointOne] = useState("");
  const [searchCheckPointTwo, setSearchCheckPointTwo] = useState("");
  const [drpDownSelectedVal, setDrpDownSelectedVal] = useState("");
  const [groupTokenSearch, setGroupTokenSearch] = useState("");
  const [qrPresent, setQrPresent] = useState(true);
  const [checkPoint, setCheckPoint] = useState(1);
  const [eventName, setEventName] = useState(null);
  const [tabs, setTab] = useState(["All", "Token Wise"]);
  // const [selectedLaunch, setSelectedLaunch] = useState("");
  // const [AllLaunches, setAllLaunches] = useState([]);
  const [tabsForMobileMenu, setTabsForMobileMenu] = useState([
    "Token Holder Leads",
    "CheckPoint One Cleared",
    "CheckPoint Two Cleared",
  ]);
  const [tokenWiseLeads, setTokenWiseLeads] = useState([]);
  const [copyTokenWiseLeads, setCopyTokenWiseLeads] = useState([]);
  const [tabValue, setTabValue] = useState("All");
  const [tabValueMobileMenu, setTabValueMobileMenu] =
    useState("Token Holder Leads");

  const launchIds = JSON.parse(sessionStorage.getItem('selectedLaunchesForQueue'));
  const allLaunches = launchId === "All" ? launchIds : [launchId];
  const selectedLaunch = allLaunches[0];

  console.log(selectedLaunch)

  useEffect(() => {
    dispatch(action.activeMenu("queue"));
    //*user -access for tabs
    if (window.innerWidth > 820) {
      let tempSideMenuArray = [];
      tabs.forEach((el, index) => {
        if (
          Object.keys(
            loggedInUser?.roleId?.accessibleTabs?.Queue?.[
            'View More'
            ]
          ).includes(el)
        ) {
          console.log(el);
          if (loggedInUser?.roleId?.accessibleTabs?.Queue?.['View More']?.[el]?.isAccessible
          ) {
            console.log(el);
            tempSideMenuArray.push(el);
          }
        }
      });
      console.log(tempSideMenuArray);
      setTab([...tempSideMenuArray]);
    } else {
      //*user-access for mobile menu
      let tempSideMenuArray1 = [];
      tabsForMobileMenu.forEach((el, index) => {
        if (
          Object.keys(loggedInUser?.roleId?.accessibleTabs?.Queue["View More"]?.['All']).includes(el)
        ) {
          // console.log("we are here", el);
          if (loggedInUser?.roleId?.accessibleTabs?.Queue["View More"]?.['All']?.[el]?.isAccessible
          ) {
            // console.log("checking on this", el);
            tempSideMenuArray1.push(el);
          }
        }
      });

      console.log(tempSideMenuArray1);
      setTabsForMobileMenu([...tempSideMenuArray1]);
    }

    // getLaunches(eventId).then((launchResp) => {
    //   console.log("getLaunches", launchResp)
    //   launchResp.data = launchResp.data.map((each) => ({
    //     ...each,
    //     label: each.title,
    //     value: each.launchId,
    //   }));
    //   setAllLaunches(whereClause)
    //   setSelectedLaunch(whereClause[0].launchId);
    // })

    getEvent(eventId).then((resp) => {
      console.log(resp);
      setEventName(resp[0].title);
    });
    console.log(eventName);
    //getLeads by eventId and status token payment done
    setAllLeads([]);
    getLeadForPaymentDone(search);
    getLeadForClearedCheckPointOne(searchCheckPointOne);
    getLeadForClearedCheckPointTwo(searchCheckPointTwo);
    getAllLeadsFromEventToken();
  }, [tabValue]);


  useEffect(() => {
    console.log({ copyTokenWiseLeads });
  }, [tokenWiseLeads]);

  const tabList = tabs.map((each, index) => {
    return (
      <Tab
        label={each}
        key={index}
        value={each}
        sx={[
          {
            fontFamily: "Inter-Medium !important",
            fontStyle: "normal !important",
            fontWeight: "500 !important",
            fontSize: "1.4rem !important",
            lineHeight: "2rem !important",
            textTransform: "none !important",
          },
        ]}
      />
    );
  });
  const tabChange = (event, newValue) => {
    console.log(newValue);
    setTabValue(newValue);
  };
  const tabMobileMenuChange = (event, newValue) => {
    console.log(newValue);
    setTabValueMobileMenu(newValue);
  };
  const tabMobileMenuList = tabsForMobileMenu.map((each, index) => {
    return (
      <Tab
        label={each}
        key={index}
        value={each}
        sx={[
          {
            fontFamily: "Inter-Medium !important",
            fontStyle: "normal !important",
            fontWeight: "500 !important",
            fontSize: "1.4rem !important",
            lineHeight: "2rem !important",
            textTransform: "none !important",
          },
        ]}
      />
    );
  });
  function getLeadForPaymentDone(search) {
    Network.getStatus().then((status) => {
      if (status.connected) {
        presentLoader();
        getLeadsForTokenPaymentDone(
          eventId,
          "Token Payment Complete",
          false,
          false,
          search,
          allLaunches
        )
          .then((resp) => {
            dismissLoader();
            // console.log("getLeadsForTokenPaymentDone", resp);

            resp.data = resp.data.map((each, index) => ({
              ...each,
              index: index,
              leadName: each?.leadId?.personId?.name,
              cpName: each?.leadId?.cpId?.billingName ?? "-",
              fosName: each?.leadId?.fosId?.name ?? "-",
              sm: each?.leadId?.userId?.name ?? "-",
              displayId:
                "VJ" +
                each?.leadId?.leadDisplayId?.replace(
                  each?.leadId?.leadDisplayId?.substring(8, 12),
                  "-" + each?.leadId?.leadDisplayId?.substring(8, 12)
                ),
              tokenName: each?.eventTokenId?.tokenId?.name,
              tokenNumber: each?.tokenNumber,
            }));
            let temp = [];
            resp.data.filter(f => f.AllotmentPayment.length === 0).forEach((el) => {
              if (
                el?.leadId?.LeadStatus?.length > 0 &&
                el?.leadId?.personId !== null
              ) {
                temp.push(el);
                console.log(el);
              }
            });
            // console.log("resp", resp)
            setAllLeads([...temp]);
            setTotalTokenHolderLeadsCount(resp?.count);
            // console.log(temp);
            //   setAllLeads([...resp.data]);
          })
          .catch((err) => {
            console.log(err);
            dismissLoader();
          });
      } else {
        offlineToast();
      }
    });
  }

  //function to get CheckPointOneCleared Leads
  function getLeadForClearedCheckPointOne(searchCheckPointOne) {
    Network.getStatus().then((status) => {
      if (status.connected) {
        presentLoader();
        getLeadsForTokenPaymentDone(
          eventId,
          "Checkpoint One Cleared",
          true,
          false,
          searchCheckPointOne,
          allLaunches
        )
          .then((resp) => {
            dismissLoader();
            resp.data = resp.data.map((each, index) => ({
              ...each,
              index: index,
              leadName: each?.leadId?.personId?.name,
              cpName: each?.leadId?.cpId?.billingName ?? "-",
              fosName: each?.leadId?.fosId?.name ?? "-",
              sm: each?.leadId?.userId?.name ?? "-",
              displayId:
                "VJ" +
                each?.leadId?.leadDisplayId?.replace(
                  each?.leadId?.leadDisplayId?.substring(8, 12),
                  "-" + each?.leadId?.leadDisplayId?.substring(8, 12)
                ),
              tokenName: each?.eventTokenId?.tokenId?.name,
              tokenNumber: each?.tokenNumber,
            }));
            let temp = [];
            resp.data.forEach((el) => {
              if (
                el?.leadId?.LeadStatus?.length > 0 &&
                el?.leadId?.personId !== null
              ) {
                temp.push(el);
              }
            });
            setLeadsClearedCheckPointOne(uniqBy([...temp], "displayId"));
            setLeadsClearedCheckPointOneCount(resp?.count);
            console.log(temp);
          })
          .catch((err) => {
            dismissLoader();
            console.log(err);
          });
      } else {
        offlineToast();
      }
    });
  }

  //function to update leadStatus "Cleared check point two"
  function getLeadForClearedCheckPointTwo(searchCheckPointTwo) {
    Network.getStatus().then((status) => {
      if (status.connected) {
        presentLoader();
        getLeadsForTokenPaymentDone(
          eventId,
          "Checkpoint Two Cleared",
          true,
          true,
          searchCheckPointTwo,
          allLaunches
        )
          .then((resp) => {
            dismissLoader();
            resp.data = resp.data.map((each, index) => ({
              ...each,
              index: index,
              leadName: each?.leadId?.personId?.name,
              cpName: each?.leadId?.cpId?.billingName ?? "-",
              fosName: each?.leadId?.fosId?.name ?? "-",
              sm: each?.leadId?.userId?.name ?? "-",
              displayId:
                "VJ" +
                each?.leadId?.leadDisplayId?.replace(
                  each?.leadId?.leadDisplayId?.substring(8, 12),
                  "-" + each?.leadId?.leadDisplayId?.substring(8, 12)
                ),
              tokenName: each?.eventTokenId?.tokenId?.name,
              tokenNumber: each?.tokenNumber,
            }));
            let temp = [];
            resp.data.forEach((el) => {
              if (
                el?.leadId?.LeadStatus?.length > 0 &&
                el?.leadId?.personId !== null
              ) {
                temp.push(el);
              }
            });
            setLeadsClearedCheckPointTwo(uniqBy([...temp], "displayId"));
            setLeadsClearedCheckPointTwoCount(resp?.count);
            console.log(temp);
          })
          .catch((err) => {
            dismissLoader();
            console.log(err);
          });
      } else {
        offlineToast();
      }
    });
  }

  function getAllLeadsFromEventToken() {
    let leadsFirstPay = [];
    Network.getStatus().then((status) => {
      if (status.connected) {
        getAllLeadsFromTokenLead(eventId, allLaunches).then((leadResp) => {
          console.log({ leadResp });
          leadResp.data = leadResp.data.map((each, index) => ({
            ...each,
            index: index,
            leadName: each?.leadId?.personId?.name,
            cpName: each?.leadId?.cpId?.billingName ?? "-",
            fosName: each?.leadId?.fosId?.name ?? "-",
            sm: each?.leadId?.userId?.name ?? "-",
            displayId:
              "VJ" +
              each?.leadId?.leadDisplayId?.replace(
                each?.leadId?.leadDisplayId?.substring(8, 12),
                "-" + each?.leadId?.leadDisplayId?.substring(8, 12)
              ),
            tokenName: each?.eventTokenId?.tokenId?.name,
            tokenNumber: each?.tokenNumber,
            leadContactNumber: each?.leadId?.personId?.contactNumber,
          }));
          let temp = [];
          leadResp.data.forEach((el) => {
            if (
              el?.leadId?.LeadStatus?.length > 0 &&
              el?.leadId?.personId !== null
            ) {
              temp.push(el);
              console.log(el);
            }
          });
          let leadsEventTokenId = [];
          temp = temp.map((resp) => ({
            ...resp,
            grpPriority: resp?.groupId?.groupPriority,
            eventTokenWise: resp?.eventTokenId?.eventTokenId,
          }));
          temp.forEach((el) => {
            leadsFirstPay.push(el);
            // ** Group by eventTokenId
          });
          leadsEventTokenId = chain(leadsFirstPay)
            .groupBy("eventTokenWise")
            .map((value, key) => ({
              eventTokenId: key,
              leads: value,
              tokenName: value[0]?.eventTokenId?.tokenId?.name,
            }))
            .value();
          console.log({ leadsEventTokenId });
          setTokenWiseLeads([...leadsEventTokenId]);
          setCopyTokenWiseLeads([...leadsEventTokenId]);
        });
      } else {
        offlineToast();
      }
    });
  }
  const debouncedFetchSearchData = debounce((e) => {
    setSearch(e.target.value);
    setAllLeads([]);
    getLeadForPaymentDone(e.target.value);
  }, 800);
  const debouncedFetchSearchDataForCheckPointOne = debounce((e) => {
    setSearchCheckPointOne(e.target.value);
    setLeadsClearedCheckPointOne([]);
    setLeadsClearedCheckPointOneCount(0);
    getLeadForClearedCheckPointOne(e.target.value);
  }, 800);
  const debouncedFetchSearchDataForCheckPointTwo = debounce((e) => {
    setSearchCheckPointTwo(e.target.value);
    setLeadsClearedCheckPointTwo([]);
    setLeadsClearedCheckPointTwoCount(0);
    getLeadForClearedCheckPointTwo(e.target.value);
  }, 800);

  return (
    <div className={cssClasses.wrapperPage}>
      <Box className={cssClasses.headerWrapper}>
        <Box className={cssClasses.headerLeftSide}>
          <Box display={"flex"} flexDirection={"column"} gap={"1rem"}>
            <Typography className={cssClasses.headerTittle}>
              {eventName}
            </Typography>
          </Box>
        </Box>
        {loggedInUser?.roleId?.accessibleTabs?.Queue["View More"]["Scan QR"]?.isAccessible && (
          <Box className={cssClasses.headerRightSide}>
            {/* <Box width={'25rem'} mr={2}>
            <DropDown
                list={AllLaunches}
                style={{
                  background: '#F2F4F7',
                  color: 'rgb(102, 112, 133)',
                }}
                selectedValue={selectedLaunch}
                onChangeSelect={(_value) => {
                  setSelectedLaunch(_value);
                  // setDrpDownSelectedVal(_value)
                  // getAllLaunchesFromServer(
                  //   0,
                  //   false,
                  //   search,
                  //   _value
                  // )
                }}
              />
            </Box> */}
            <Box mt={0.6}>
              <Button
                style={{
                  color: "#fff",
                  backgroundColor: "#1570EF",
                  fontSize: "1.4rem",
                  lineHeight: "2rem",
                  fontFamily: "Roboto-Regular",
                }}
                btnName={"Scan QR"}
                clicked={() => {
                  setQrPresent(true);
                  setScanConformationModal(true);
                }}
                btnIcon={
                  <CropFreeIcon style={{ width: "15px", height: "15px" }} />
                }
                iconPosition={"left"}
              />
            </Box>
          </Box>
        )}

      </Box>
      <Tabs
        value={tabValue}
        onChange={tabChange}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
        sx={[
          {
            borderBottom: "1px solid #EAECF0 !important",
          },
        ]}
      >
        {tabList}
      </Tabs>
      <div className={cssClasses.mainWrapper}>
        {/* Events */}

        <Box className={cssClasses.checkPointWrapper}>
          {tabValue === "All" && (
            <>
              {window.innerWidth > 820 ? (
                <>
                  {loggedInUser?.roleId?.accessibleTabs?.Queue["View More"]?.All["Token Holder Leads"]?.isAccessible && (
                    <>
                      <div className={cssClasses.cardWrapper}>
                        <div className={cssClasses.cardHeader}>
                          <p>
                            Token Holder Leads
                            <span style={{ marginLeft: "1rem" }}>
                              {totalTokenHolderLeadsCount !== 0 &&
                              totalTokenHolderLeadsCount > 0
                                ? `(${totalTokenHolderLeadsCount})`
                                : "(0)"}
                            </span>
                          </p>
                          <div>
                            <Search
                              sxStyle={{
                                " .MuiInputBase-root": {
                                  background: "#FFFFFF !important",
                                },
                              }}
                              search={debouncedFetchSearchData}
                              id={"allTokenSearch"}
                              placeholder={"Search here..."}
                              width={"18rem"}
                            />
                          </div>
                        </div>
                        <div className={cssClasses.cardContentContainer}>
                          {allLeads !== null &&
                            allLeads.length > 0 &&
                            allLeads.map((lead, index) => {
                              return (
                                <div
                                  className={cssClasses.cardContent}
                                  key={`CheckPoint_${index + 1}`}
                                >
                                  <div className={cssClasses.cardTextWrapper}>
                                    <p className={cssClasses.leadNameText}>
                                      <span>{index + 1}.</span> {lead.leadName}
                                    </p>
                                    <p className={cssClasses.cardText}>
                                      <span>CP: </span>
                                      {lead.cpName}
                                    </p>
                                    <p className={cssClasses.cardText}>
                                      VJ{lead.tokenNumber}
                                    </p>
                                    <p className={cssClasses.cardText}>
                                      <span>SM:</span>
                                      {lead.sm}
                                    </p>
                                    <Box
                                      display={"flex"}
                                      flexDirection={"row"}
                                      gap={"1rem"}
                                      alignItems={"center"}
                                      flex={"0 0 100%"}
                                    >
                                      <StatusChip
                                        style={{
                                          color: "#6927DA",
                                          backgroundColor: "#EBE9FE",
                                        }}
                                        label={lead.tokenName}
                                      />
                                      <p className={cssClasses.cardText}>
                                        <span>{lead.displayId}</span>
                                      </p>
                                    </Box>
                                  </div>
                                  {loggedInUser?.roleId?.accessibleTabs?.Queue["View More"]?.All["Token Holder Leads"]["Token Holder Leads Generate"]?.isAccessible && (
                                    <>
                                      <div className={cssClasses.cardButtonWrapper}>
                                        <Button
                                          style={{
                                            color: "#ffffff",
                                            backgroundColor: "#155EEF",
                                            fontSize: "1.3rem",
                                            lineHeight: "2rem",
                                          }}
                                          btnName={"Generate"}
                                          clicked={() => {
                                            console.log(lead);
                                            setCheckPoint(1);
                                            setLeadData(lead);
                                            setQrPresent(false);
                                            setScanConformationModal(true);
                                          }}
                                        />
                                        {/* <button
                                  className={cssClasses.CardArrowButton}
                                  onClick={() => {
                                    console.log(lead);
                                    setCheckPoint(1);
                                    setLeadData(lead);
                                    setQrPresent(false);
                                    setScanConformationModal(true);
                                  }}
                                >
                                  <KeyboardDoubleArrowRightIcon
                                    style={{ width: "2rem", height: "2rem" }}
                                  />
                                </button> */}
                                      </div></>
                                  )}

                                </div>
                              );
                            })}
                          {(allLeads === null || allLeads.length === 0) && (
                            <div className={cssClasses.noTokensAvailable}>
                              No Token Holders Available
                            </div>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                  {loggedInUser?.roleId?.accessibleTabs?.Queue["View More"]?.All["CheckPoint One Cleared"]?.isAccessible && (
                    <div className={cssClasses.cardWrapper}>
                      <div className={cssClasses.cardHeader}>
                        <p>
                          Check Pt.1 Cleared{" "}
                          <span style={{ marginLeft: "1rem" }}>
                            {leadsClearedCheckPointOneCount !== 0 &&
                            leadsClearedCheckPointOneCount > 0
                              ? `(${leadsClearedCheckPointOneCount})`
                              : "(0)"}
                          </span>
                        </p>
                        <div>
                          <Search
                            sxStyle={{
                              " .MuiInputBase-root": {
                                background: "#FFFFFF !important",
                              },
                            }}
                            search={debouncedFetchSearchDataForCheckPointOne}
                            placeholder={"Search here..."}
                            width={"18rem"}
                            id={"chkptOneSearch"}
                          />
                        </div>
                      </div>
                      <div className={cssClasses.cardContentContainer}>
                        {leadsClearedCheckPointOne !== null &&
                          leadsClearedCheckPointOne.map((lead, index) => {
                            return (
                              <div
                                className={cssClasses.cardContent}
                                key={`CheckPoint_${index + 1}`}
                              >
                                <div className={cssClasses.cardTextWrapper}>
                                  <p className={cssClasses.leadNameText}>
                                    <span>{index + 1}.</span> {lead.leadName}
                                  </p>
                                  <p className={cssClasses.cardText}>
                                    <span>CP: </span>
                                    {lead.cpName}
                                  </p>
                                  <p className={cssClasses.cardText}>
                                    VJ{lead.tokenNumber}
                                  </p>
                                  <p className={cssClasses.cardText}>
                                    <span>SM:</span>
                                    {lead.sm}
                                  </p>
                                  <p className={cssClasses.cardText}>
                                    <span>
                                      Band Number:{lead.displayBandNumber}
                                    </span>
                                  </p>
                                  <Box
                                    display={"flex"}
                                    flexDirection={"row"}
                                    gap={"1rem"}
                                    alignItems={"center"}
                                    flex={"0 0 100%"}
                                  >
                                    <StatusChip
                                      style={{
                                        color: "#6927DA",
                                        backgroundColor: "#EBE9FE",
                                      }}
                                      label={lead.tokenName}
                                    />
                                    <p className={cssClasses.cardText}>
                                      <span>{lead.displayId}</span>
                                    </p>
                                  </Box>
                                </div>
                                {loggedInUser?.roleId?.accessibleTabs?.Queue["View More"]?.All["CheckPoint One Cleared"]["Check Point1 Cleared Generate"]?.isAccessible && (
                                  <>
                                    <div className={cssClasses.cardButtonWrapper}>
                                      <button
                                        className={cssClasses.CardArrowButton}
                                        onClick={() => {
                                          setLeadData(lead);
                                          setCheckPoint(2);
                                          setQrPresent(false);
                                          setScanConformationModal(true);
                                        }}
                                      >
                                        <KeyboardDoubleArrowRightIcon
                                          style={{ width: "2rem", height: "2rem" }}
                                        />
                                      </button>
                                    </div>
                                  </>
                                )}

                              </div>
                            );
                          })}
                        {(leadsClearedCheckPointOne === null ||
                          leadsClearedCheckPointOne.length === 0) && (
                            <div className={cssClasses.noTokensAvailable}>
                              No Leads Available
                            </div>
                          )}
                      </div>
                    </div>
                  )}
                  {loggedInUser?.roleId?.accessibleTabs?.Queue["View More"]?.All["CheckPoint Two Cleared"]?.isAccessible && (
                    <>
                      <div className={cssClasses.cardWrapper}>
                        <div className={cssClasses.cardHeader}>
                          <p>
                            Check Pt.2 Cleared{" "}
                            <span style={{ marginLeft: "1rem" }}>
                              {leadsClearedCheckPointTwoCount !== 0 &&
                              leadsClearedCheckPointTwoCount > 0
                                ? `(${leadsClearedCheckPointTwoCount})`
                                : "(0)"}
                            </span>
                          </p>
                          <div>
                            <Search
                              sxStyle={{
                                " .MuiInputBase-root": {
                                  background: "#FFFFFF !important",
                                },
                              }}
                              search={debouncedFetchSearchDataForCheckPointTwo}
                              placeholder={"Search here..."}
                              width={"18rem"}
                              id={"chkptTwoSearch"}
                            />
                          </div>
                        </div>
                        <div className={cssClasses.cardContentContainer}>
                          {leadsClearedCheckPointTwo !== null &&
                            leadsClearedCheckPointTwo.map((lead, index) => {
                              return (
                                <div
                                  className={cssClasses.cardContent}
                                  key={`CheckPoint_${index + 1}`}
                                >
                                  <div className={cssClasses.cardTextWrapper}>
                                    <p className={cssClasses.leadNameText}>
                                      <span>{index + 1}.</span> {lead.leadName}
                                    </p>
                                    <p className={cssClasses.cardText}>
                                      <span>CP: </span>
                                      {lead.cpName}
                                    </p>
                                    <p className={cssClasses.cardText}>
                                      VJ{lead.tokenNumber}
                                    </p>
                                    <p className={cssClasses.cardText}>
                                      <span>SM:</span>
                                      {lead.sm}
                                    </p>
                                    <p className={cssClasses.cardText}>
                                      <span>
                                        Band Number:{lead.displayBandNumber}
                                      </span>
                                    </p>
                                    <Box
                                      display={"flex"}
                                      flexDirection={"row"}
                                      gap={"1rem"}
                                      alignItems={"center"}
                                      flex={"0 0 100%"}
                                    >
                                      <StatusChip
                                        style={{
                                          color: "#6927DA",
                                          backgroundColor: "#EBE9FE",
                                        }}
                                        label={lead.tokenName}
                                      />
                                      <p className={cssClasses.cardText}>
                                        <span>{lead.displayId}</span>
                                      </p>
                                    </Box>
                                  </div>
                                  {/* <div className={cssClasses.cardButtonWrapper}>
              <button
                className={cssClasses.CardArrowButton}
                onClick={() => {
                  setClearedCheckPointModal(true);
                  setLeadData(lead);
                }}
              >
                <KeyboardDoubleArrowRightIcon
                  style={{ width: "2rem", height: "2rem" }}
                />
              </button>
            </div> */}
                                </div>
                              );
                            })}
                          {(leadsClearedCheckPointTwo === null ||
                            leadsClearedCheckPointTwo.length === 0) && (
                              <div className={cssClasses.noTokensAvailable}>
                                No Leads Available
                              </div>
                            )}
                        </div>
                      </div>
                    </>
                  )}

                </>
              ) : (
                <>
                  <Tabs
                    value={tabValueMobileMenu}
                    onChange={tabMobileMenuChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="scrollable auto tabs example"
                    sx={[
                      {
                        borderBottom: "1px solid #EAECF0 !important",
                      },
                    ]}
                  >
                    {tabMobileMenuList}
                  </Tabs>
                  <>
                    {tabValueMobileMenu === "Token Holder Leads" && (
                      <div className={cssClasses.cardWrapper}>
                        <div className={cssClasses.cardHeader}>
                          <p>Token Holder Leads<span style={{ marginLeft: "1rem" }}>{(allLeads !== null && allLeads.length > 0) ? `(${allLeads.length})` : "(0)"}</span></p>

                          <div>
                            <Search
                              sxStyle={{
                                " .MuiInputBase-root": {
                                  background: "#FFFFFF !important",
                                },
                              }}
                              search={debouncedFetchSearchData}
                              id={"allTokenSearch"}
                              placeholder={"Search here..."}
                              width={"18rem"}
                            />
                          </div>
                        </div>
                        <div className={cssClasses.cardContentContainer}>
                          {allLeads !== null &&
                            allLeads.length > 0 &&
                            allLeads.map((lead, index) => {
                              return (
                                <div
                                  className={cssClasses.cardContent}
                                  key={`CheckPoint_${index + 1}`}
                                >
                                  <div className={cssClasses.cardTextWrapper}>
                                    <p className={cssClasses.leadNameText}>
                                      <span>{index + 1}.</span> {lead.leadName}
                                    </p>
                                    <p className={cssClasses.cardText}>
                                      <span>CP: </span>
                                      {lead.cpName}
                                    </p>
                                    <p className={cssClasses.cardText}>
                                      VJ{lead.tokenNumber}
                                    </p>
                                    <p className={cssClasses.cardText}>
                                      <span>SM:</span>
                                      {lead.sm}
                                    </p>
                                    <Box
                                      display={"flex"}
                                      flexDirection={"row"}
                                      gap={"1rem"}
                                      alignItems={"center"}
                                      flex={"0 0 100%"}
                                    >
                                      <StatusChip
                                        style={{
                                          color: "#6927DA",
                                          backgroundColor: "#EBE9FE",
                                        }}
                                        label={lead.tokenName}
                                      />
                                      <p className={cssClasses.cardText}>
                                        <span>{lead.displayId}</span>
                                      </p>
                                    </Box>
                                  </div>
                                  {loggedInUser?.roleId?.accessibleTabs?.Queue["View More"]?.All["Token Holder Leads"]["Token Holder Leads Generate"]?.isAccessible && (
                                    <>
                                      <div className={cssClasses.cardButtonWrapper}>
                                        <button
                                          className={cssClasses.CardArrowButton}
                                          onClick={() => {
                                            console.log(lead);
                                            setCheckPoint(1);
                                            setLeadData(lead);
                                            setQrPresent(false);
                                            setScanConformationModal(true);
                                          }}
                                        >
                                          <KeyboardDoubleArrowRightIcon
                                            style={{
                                              width: "2rem",
                                              height: "2rem",
                                            }}
                                          />
                                        </button>
                                      </div>
                                    </>

                                  )}

                                </div>
                              );
                            })}
                          {(allLeads === null || allLeads.length === 0) && (
                            <div className={cssClasses.noTokensAvailable}>
                              No Token Holders Available
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                    {tabValueMobileMenu === "CheckPoint One Cleared" && (
                      <div className={cssClasses.cardWrapper}>
                        <div className={cssClasses.cardHeader}>
                          <p>
                            Check Pt.1 Cleared
                            <span style={{ marginLeft: "1rem" }}>
                              {leadsClearedCheckPointOne !== null &&
                              leadsClearedCheckPointOne.length > 0
                                ? `(${leadsClearedCheckPointOne.length})`
                                : "(0)"}
                            </span>
                          </p>
                          <div>
                            <Search
                              sxStyle={{
                                " .MuiInputBase-root": {
                                  background: "#FFFFFF !important",
                                },
                              }}
                              search={debouncedFetchSearchDataForCheckPointOne}
                              placeholder={"Search here..."}
                              width={"18rem"}
                              id={"chkptOneSearch"}
                            />
                          </div>
                        </div>
                        <div className={cssClasses.cardContentContainer}>
                          {leadsClearedCheckPointOne !== null &&
                            leadsClearedCheckPointOne.map((lead, index) => {
                              return (
                                <div
                                  className={cssClasses.cardContent}
                                  key={`CheckPoint_${index + 1}`}
                                >
                                  <div className={cssClasses.cardTextWrapper}>
                                    <p className={cssClasses.leadNameText}>
                                      <span>{index + 1}.</span> {lead.leadName}
                                    </p>
                                    <p className={cssClasses.cardText}>
                                      <span>CP: </span>
                                      {lead.cpName}
                                    </p>
                                    <p className={cssClasses.cardText}>
                                      VJ{lead.tokenNumber}
                                    </p>
                                    <p className={cssClasses.cardText}>
                                      <span>SM:</span>
                                      {lead.sm}
                                    </p>
                                    <p className={cssClasses.cardText}>
                                      <span>
                                        Band Number:{lead.displayBandNumber}
                                      </span>
                                    </p>
                                    <Box
                                      display={"flex"}
                                      flexDirection={"row"}
                                      gap={"1rem"}
                                      alignItems={"center"}
                                      flex={"0 0 100%"}
                                    >
                                      <StatusChip
                                        style={{
                                          color: "#6927DA",
                                          backgroundColor: "#EBE9FE",
                                        }}
                                        label={lead.tokenName}
                                      />
                                      <p className={cssClasses.cardText}>
                                        <span>{lead.displayId}</span>
                                      </p>
                                    </Box>
                                  </div>
                                  {loggedInUser?.roleId?.accessibleTabs?.Queue["View More"]?.All["CheckPoint One Cleared"]["Check Point1 Cleared Generate"]?.isAccessible && (
                                    <>
                                      <div className={cssClasses.cardButtonWrapper}>
                                        <button
                                          className={cssClasses.CardArrowButton}
                                          onClick={() => {
                                            setLeadData(lead);
                                            setCheckPoint(2);
                                            setQrPresent(false);
                                            setScanConformationModal(true);
                                          }}
                                        >
                                          <KeyboardDoubleArrowRightIcon
                                            style={{
                                              width: "2rem",
                                              height: "2rem",
                                            }}
                                          />
                                        </button>
                                      </div>
                                    </>
                                  )}

                                </div>
                              );
                            })}
                          {(leadsClearedCheckPointOne === null ||
                            leadsClearedCheckPointOne.length === 0) && (
                              <div className={cssClasses.noTokensAvailable}>
                                No Leads Available
                              </div>
                            )}
                        </div>
                      </div>
                    )}
                    {tabValueMobileMenu === "CheckPoint Two Cleared" && (
                      <div className={cssClasses.cardWrapper}>
                        <div className={cssClasses.cardHeader}>
                          <p>
                            Check Pt.2 Cleared
                            <span style={{ marginLeft: "1rem" }}>
                              {leadsClearedCheckPointTwo !== null &&
                              leadsClearedCheckPointTwo.length > 0
                                ? `(${leadsClearedCheckPointTwo.length})`
                                : "(0)"}
                            </span>
                          </p>
                          <div>
                            <Search
                              sxStyle={{
                                " .MuiInputBase-root": {
                                  background: "#FFFFFF !important",
                                },
                              }}
                              search={debouncedFetchSearchDataForCheckPointTwo}
                              placeholder={"Search here..."}
                              width={"18rem"}
                              id={"chkptTwoSearch"}
                            />
                          </div>
                        </div>
                        <div className={cssClasses.cardContentContainer}>
                          {leadsClearedCheckPointTwo !== null &&
                            leadsClearedCheckPointTwo.map((lead, index) => {
                              return (
                                <div
                                  className={cssClasses.cardContent}
                                  key={`CheckPoint_${index + 1}`}
                                >
                                  <div className={cssClasses.cardTextWrapper}>
                                    <p className={cssClasses.leadNameText}>
                                      <span>{index + 1}.</span> {lead.leadName}
                                    </p>
                                    <p className={cssClasses.cardText}>
                                      <span>CP: </span>
                                      {lead.cpName}
                                    </p>
                                    <p className={cssClasses.cardText}>
                                      VJ{lead.tokenNumber}
                                    </p>
                                    <p className={cssClasses.cardText}>
                                      <span>SM:</span>
                                      {lead.sm}
                                    </p>
                                    <p className={cssClasses.cardText}>
                                      <span>
                                        Band Number:{lead.displayBandNumber}
                                      </span>
                                    </p>
                                    <Box
                                      display={"flex"}
                                      flexDirection={"row"}
                                      gap={"1rem"}
                                      alignItems={"center"}
                                      flex={"0 0 100%"}
                                    >
                                      <StatusChip
                                        style={{
                                          color: "#6927DA",
                                          backgroundColor: "#EBE9FE",
                                        }}
                                        label={lead.tokenName}
                                      />
                                      <p className={cssClasses.cardText}>
                                        <span>{lead.displayId}</span>
                                      </p>
                                    </Box>
                                  </div>
                                </div>
                              );
                            })}
                          {(leadsClearedCheckPointTwo === null ||
                            leadsClearedCheckPointTwo.length === 0) && (
                              <div className={cssClasses.noTokensAvailable}>
                                No Leads Available
                              </div>
                            )}
                        </div>
                      </div>
                    )}
                  </>
                </>
              )}
            </>
          )}
          {/* loggedInUser?.roleId?.accessibleTabs?.Queue["Token Wise"]["Token Name"]?.isAccessible && */}
          {tabValue === "Token Wise" &&
            tokenWiseLeads.length > 0 &&
            tokenWiseLeads.map((each, index) => {
              return (
                <QueueBlocks
                  group={each}
                  grpIndex={index}
                  handleChange={(lead) => {
                    setCheckPoint(1);
                    setLeadData(lead);
                    setQrPresent(false);
                    setScanConformationModal(true);
                  }}
                />
              );
            })}
          {/* !loggedInUser?.roleId?.accessibleTabs?.Queue["Token Wise"]["Token Name"]?.isAccessible && */}
          {tabValue === "Token Wise" && tokenWiseLeads.length === 0 && (
            <div className={cssClasses.noTokensAvailableTransform}>
              No Leads Available
            </div>
          )}
        </Box>
      </div>
      {scanConformationModal && (
        <ScanConformationModal
          open={scanConformationModal}
          buttonRes={(value) => {
            if (value) {
              setAllLeads([]);
              setLeadsClearedCheckPointOne([]);
              setLeadsClearedCheckPointTwo([]);
              setLeadsClearedCheckPointOneCount(0);
              setLeadsClearedCheckPointTwoCount(0);
              setSearch("");
              setSearchCheckPointOne("");
              setSearchCheckPointTwo("");
              setScanConformationModal(false);
              getLeadForPaymentDone("");
              getLeadForClearedCheckPointOne("");
              getLeadForClearedCheckPointTwo("");
              getAllLeadsFromEventToken();
              document.getElementById(
                "input-with-icon-textfield allTokenSearch"
              ).value = "";
              document.getElementById(
                "input-with-icon-textfield chkptOneSearch"
              ).value = "";
              document.getElementById(
                "input-with-icon-textfield chkptTwoSearch"
              ).value = "";
            }
          }}
          handleClose={() => {

            setAllLeads([]);
            setLeadsClearedCheckPointOne([]);
            setLeadsClearedCheckPointTwo([]);
            setLeadsClearedCheckPointOneCount(0);
            setLeadsClearedCheckPointTwoCount(0);
            setSearch("");
            setSearchCheckPointOne("");
            setSearchCheckPointTwo("");
            setScanConformationModal(false);
            getLeadForPaymentDone("");
            getLeadForClearedCheckPointOne("");
            getLeadForClearedCheckPointTwo("");
            getAllLeadsFromEventToken();
            document.getElementById(
              "input-with-icon-textfield allTokenSearch"
            ).value = "";
            document.getElementById(
              "input-with-icon-textfield chkptOneSearch"
            ).value = "";
            document.getElementById(
              "input-with-icon-textfield chkptTwoSearch"
            ).value = "";
          }}
          leadsData={leadData}
          qrPresent={qrPresent}
          checksPoint={checkPoint}
          eventId={eventId}
          launchIds={selectedLaunch}
          paramLaunchId={launchId}
        />
      )}
    </div>
  );
}

export default EventQueuePage;
